import React, { useState } from "react";
import AnalyzeScript from "./AnalyzeScript/AnalyzeScript";

import "./styles.scss";

const ScriptAnalysis = () => {
  const [active, setActive] = useState("analyzeScript");

  return (
    <div className="url-analysis__content ">
      <div className="url-analysis__tabs">
        <div
          className={`url-analysis__tabs${active === "analyzeScript" ? "--active" : ""}`}
          onClick={() => setActive("analyzeScript")}>
          Write your Script Here:
        </div>
      </div>
      <div className="file-analysis__component">
        <AnalyzeScript />
      </div>
    </div>
  );
};

export default ScriptAnalysis;
